/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneLink as ResolvedStandaloneLink } from 'base/components/standalone/Link';

export const Link: typeof ResolvedStandaloneLink = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneLink {...props} />
        </ErrorBoundary>
    );
});

export type LinkProps = PropsFromComponent<typeof Link>;

/** @deprecated Use slot architecture instead */
export const LinkWith = (extras: DynamicStandaloneExtras): typeof Link => {
    return function Link(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Link');
        return <ResolvedStandaloneLink {...mergeProps({ options: { theme } }, props)} />;
    }
}